import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import React from 'react';
import { IS_STRESS_CHECK_IMPLEMENTER_BUILD } from '~/constants';
import { useStressAssessmentList } from './hooks';
import { convertToStressAssessmentListProps } from './logics';
import { StressAssessmentListPresentation } from './presentations';

export const StressAssessmentList: React.FC = () => {
  const {
    state: { data, isLoading, currentPage, totalPage, totalCount },
    actions: { handlePageChange, handleRowClick },
  } = useStressAssessmentList();

  if (isLoading || !data) return null;

  const { conductedStressAssessments } = convertToStressAssessmentListProps({ data });

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount,
    rows: conductedStressAssessments,
    onPageChange: handlePageChange,
  });

  return (
    <StressAssessmentListPresentation
      conductedStressAssessments={conductedStressAssessments}
      onRowClick={handleRowClick}
      pagerProps={pagerProps}
      showCreateButton={!IS_STRESS_CHECK_IMPLEMENTER_BUILD}
    />
  );
};
